import PropTypes from 'prop-types';

const InputPropType = {
  error: PropTypes.string.isRequired,
  hideMessage: PropTypes.func,
};

export default InputPropType;
